import React from 'react';
import LazyImage from '../LazyImage';
import './Expect.css';
import expectImage from '../../assets/images/expect.webp';
import expectSmallImage from '../../assets/images/expect-sm.webp';
import aboutPersonBackImage from '../../assets/images/about-person-back.webp';
import aboutPersonBackSmallImage from '../../assets/images/about-person-back-sm.webp';
import tickIcon from '../../assets/icons/tick.png';

const Expect = () => {
    const expectPoints = [
        "Online Preparation, Review & Secure Lodgement",
        "Detailed ATO Portal Reconciliation (Interest, Dividends, Income)",
        "Registered Tax Agent Review Before Submission",
        "Guidance On Eligible Deductions",
        "Year-Round General Tax Support (Not Just During Tax Season)",
        "All For A Fixed, Tax-Deductible Fee"
    ];

    return (
        <section className="expect">
            <div className="expect-container">
                <div className="expect-content">
                    <div className="expect-left">
                        <div className="expect-tag">
                            What to Expect
                        </div>
                        <h2 className="expect-heading">
                            Expert Support.<br />
                            <span className="text-primary">Real Results.</span>
                        </h2>
                        <div className="expect-description">
                            From accuracy to affordability, our process is built to give you 
                            complete peace of mind. We make sure your return is handled 
                            with precision — and that you always know what to expect.
                        </div>
                        <div className="expect-points">
                            {expectPoints.map((point, index) => (
                                <div key={index} className="expect-point">
                                    <img 
                                        src={tickIcon} 
                                        alt="Checkmark" 
                                        className="tick-icon"
                                    />
                                    <span className="point-text">{point}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="expect-right">
                        <div className="expect-image-container">
                            <LazyImage 
                                src={aboutPersonBackImage} 
                                smallSrc={aboutPersonBackSmallImage}
                                alt="Background layer" 
                                className="expect-person-back"
                            />
                            <LazyImage 
                                src={expectImage} 
                                smallSrc={expectSmallImage}
                                alt="Professional tax experts providing expert support" 
                                className="expect-person-image"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Expect;